import React from 'react';
import { ColorChoice } from '@gift/attributes-color-core/ColorAttributeOptions';
import { useTranslation } from 'react-i18next';
import styles from './ColorAttributeRadio.module.scss';

export const ColorAttributeRadio = (choice: ColorChoice) => {
    const { t } = useTranslation();
    return (
        <>
            {t(choice.label)}
            <div className={styles.preview} style={{ backgroundColor: choice.value }} />
        </>
    );
};
